import { ReactElement } from 'react';
import { Header, Paragraph } from '@designSystem/typings';
import Lang from '@lang/en';
import Button from '@root/src/app/designSystem/buttons';
import { HeaderRow, ModalButtonsRow, ModalContainer, ModalRow } from './styles';
import { CloseMark } from '@root/src/assets/images';
import useDeleteOrder from './useDeleteOrder';

interface PropsI {
  orderId: number;
  handleClose: () => void;
}

const DeleteOrder = ({ orderId, handleClose }: PropsI): ReactElement => {
  const { deleteOrder } = useDeleteOrder();

  const handleDeleteOrder = (orderId: number) => {
    deleteOrder(orderId);
  };

  return (
    <ModalContainer>
      <HeaderRow>
        <Header data-testid="healthcheck-order-edit-modal-header">
          {Lang.healthCheckDeleteOrderLabel}
        </Header>
        <CloseMark onClick={handleClose} />
      </HeaderRow>
      <ModalRow>
        <Paragraph>{Lang.healthCheckDeleteOrderText}</Paragraph>
      </ModalRow>
      <ModalButtonsRow>
        <Button
          type="tertiary"
          data-testid="healthcheck-modal-order-delete-cannel-button"
          label={Lang.cancelText}
          onClick={handleClose}
        />
        <Button
          type="danger"
          data-testid="healthcheck-modal-order-delete-remove-button"
          label={Lang.removeText}
          onClick={() => handleDeleteOrder(orderId)}
        />
      </ModalButtonsRow>
    </ModalContainer>
  );
};

export default DeleteOrder;
